

export interface BackendError {
  message: string;
  locations?: Array<{ line: number; column: number }>;
  path?: string[];
  extensions?: {
    code: string;
    statusCode: number;
    errorCode?: string;
    field?: string;
  };
}

export interface ParsedError {
  message: string;
  code?: string;
  statusCode?: number;
  errorCode?: string;
  field?: string;
  path?: string[];
  originalError: BackendError;
}

export interface ParsedErrorResult {
  hasErrors: boolean;
  errors: ParsedError[];
  firstError?: ParsedError;
}

export enum EStatusCode {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  TOO_MANY_REQUESTS = 429,
  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  SERVICE_UNAVAILABLE = 503,
}




export enum EErrorCode {
  CALENDAR_AUTH_REQUIRED = "CALENDAR_AUTH_REQUIRED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  AUTH_INVALID_TOKEN = "AUTH_INVALID_TOKEN",
  NO_PREFERRED_CLINICS = "NO_PREFERRED_CLINICS",
  SIGNUP_IDENTITY_UNVERIFIED = "SIGNUP_IDENTITY_UNVERIFIED",
  ACCOUNT_DISABLED = "ACCOUNT_DISABLED",
}